/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState, useEffect } from "react";
import TimezoneSelect, { allTimezones } from "react-timezone-select";
import moment from "moment-timezone";

export function CustomTimeZone({ ccmodesetting, setFieldValue }) {
    const [tz, setTz] = useState(
        ccmodesetting && ccmodesetting.timeZone !== null
            ? ccmodesetting.timeZone
            : "Etc/GMT"
    );
    const [datetime, setDatetime] = useState(moment());

    useMemo(() => {
        const tzValue = tz.value ?? tz;
        setDatetime(datetime.tz(tzValue));
    }, [tz, datetime]);

    useEffect(() => {
        if (ccmodesetting && ccmodesetting.timeZone) {
            setTz(
                ccmodesetting && ccmodesetting.timeZone !== null
                    ? ccmodesetting.timeZone
                    : tz
            );
        } else {
            setFieldValue(
                "timeZone",
                Intl.DateTimeFormat().resolvedOptions().timeZone
            );
            setTz(Intl.DateTimeFormat().resolvedOptions().timeZone);
        }
    }, [ccmodesetting]);

    useEffect(() => {
        setFieldValue("timeZone", tz.value ? tz.value : tz);
    }, [tz]);

    return (
        <>
            <TimezoneSelect
                value={tz.value ? tz.value : tz}
                displayValue={"UTC"}
                onChange={setTz}
                timezones={{
                    ...allTimezones,
                    "America/Lima": "Pittsburgh",
                    "Europe/Berlin": "Frankfurt",
                }}
            />
        </>
    );
}
